import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';
import { snakeToCamel, camelToSnake } from '../lib/utils';
import { logAction } from '../lib/actionLogger';

function mapFromDb(row) { return snakeToCamel(row); }
function mapToDb(obj) { return camelToSnake(obj); }

export function useWikiArticles() {
  return useQuery({
    queryKey: queryKeys.wikiArticles.all,
    queryFn: async () => {
      const data = await api.get('/wiki-articles');
      return data.map(mapFromDb);
    },
  });
}

export function useCreateWikiArticle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (entry) => {
      const data = await api.post('/wiki-articles', mapToDb(entry));
      return mapFromDb(data);
    },
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: queryKeys.wikiArticles.all });
      logAction({
        action: 'Create How-To Entry',
        details: { title: data.title, category: data.category },
      });
    },
  });
}

export function useUpdateWikiArticle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (entry) => {
      const { id, ...updates } = entry;
      const data = await api.put(`/wiki-articles/${id}`, mapToDb(updates));
      return mapFromDb(data);
    },
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: queryKeys.wikiArticles.all });
      logAction({
        action: 'Update How-To Entry',
        details: { title: data.title, category: data.category },
      });
    },
  });
}

export function useDeleteWikiArticle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      await api.del(`/wiki-articles/${id}`);
      return id;
    },
    onSuccess: (id) => {
      qc.invalidateQueries({ queryKey: queryKeys.wikiArticles.all });
      logAction({ action: 'Delete How-To Entry', details: { id } });
    },
  });
}
